export default defineAppConfig({
  homePageConfig: {
    titleKey: 'bl_newss1_title',
    censored: false,
    homePageVersion: null,
    loaderHomeVer: null,
    loaderTitles: null,
  },
});

declare module '@nuxt/schema' {
  interface AppConfigInput {
    homePageConfig?: {
      titleKey: string
      censored: boolean
      homePageVersion: string | null
      loaderHomeVer: string | null
      loaderTitles: Record<string, string> | null
      useCustomInjectLoader?: boolean
    }
  }
}
